import React from 'react'

import TicketDetailsClientInformation from 'Components/Tickets/Details/ClientInformation'
import TicketDetailsTicketInformation from 'Components/Tickets/Details/TicketInformation'

const TicketDetails = ({
  current_user,
  ticket,
  ticket_types,
  ticket_statuses,
  paths,
  problems,
  problemEndPoint,
  problemViewer,
  updateAlert,
  updateTicket,
  collectHistory,
  roles,
  statusIds,
  allServiceCategories,
  assignCurrentUser
}) => {
  if (current_user.calligo_employee) {
    return (
      <section className="card">
        <TicketDetailsClientInformation
          current_user={current_user}
          ticket={ticket}
          updateAlert={updateAlert}
          updateTicket={updateTicket}
          collectHistory={collectHistory}
          roles={roles}
          clientPath={_.find(paths, { 'name': 'clientPath' }).path}
          assignCurrentUser={assignCurrentUser}
          ticket_types={ticket_types}
        />
      </section>
    )
  }

  return (
    <section className="card">
      <TicketDetailsClientInformation
        current_user={current_user}
        ticket={ticket}
        roles={roles}
        ticket_types={ticket_types}
      />
      <TicketDetailsTicketInformation
        currentUser={current_user}
        ticket={ticket}
        ticket_types={ticket_types}
        ticket_statuses={ticket_statuses}
        problems={problems}
        problemEndPoint={problemEndPoint}
        problemViewer={problemViewer}
        statusIds={statusIds}
        allServiceCategories={allServiceCategories}
      />
    </section>
  )
}

export default TicketDetails
